/**
 * Bind MooseDesk chat to the Shopify customer account.
 * On logout / account switch: nuclear-clear browser chat state and reload
 * so the next account never inherits the previous conversation.
 */
(function () {
  if (window.ETN && window.ETN.__mooseSessionReady) return;

  var KEY = "etn_md_customer_key";
  var RELOAD_FLAG = "etn_md_reloading";
  var PENDING_RESET = "etn_md_pending_reset";

  function ensureEtn() {
    window.ETN = window.ETN || {};
    return window.ETN;
  }

  function currentCustomerKey() {
    var id = window.ETN_SHOPIFY_CUSTOMER_ID;
    if (id == null || id === "" || id === 0 || id === "0") return "guest";
    return String(id);
  }

  function keepEtnKey(name) {
    var n = String(name || "");
    return n.indexOf("etn_") === 0;
  }

  /** Wipe almost everything — MooseDesk keys are often opaque UUIDs. */
  function nuclearClearStores() {
    var keepLocal = {};
    var i;
    var k;

    try {
      for (i = localStorage.length - 1; i >= 0; i--) {
        k = localStorage.key(i);
        if (keepEtnKey(k)) keepLocal[k] = localStorage.getItem(k);
      }
      localStorage.clear();
      Object.keys(keepLocal).forEach(function (key) {
        try {
          localStorage.setItem(key, keepLocal[key]);
        } catch (e) {}
      });
    } catch (e) {}

    try {
      // Keep only the in-flight reload flag if present
      var reloading = sessionStorage.getItem(RELOAD_FLAG);
      var pending = sessionStorage.getItem(PENDING_RESET);
      sessionStorage.clear();
      if (reloading) sessionStorage.setItem(RELOAD_FLAG, reloading);
      if (pending) sessionStorage.setItem(PENDING_RESET, pending);
    } catch (e) {}
  }

  function clearAllReadableCookies() {
    var parts = String(document.cookie || "").split(";");
    var host = location.hostname || "";
    var bare = host.replace(/^www\./, "");
    var domains = ["", host, "." + bare, "." + host];
    var paths = ["/", location.pathname || "/"];

    parts.forEach(function (part) {
      var name = part.split("=")[0].trim();
      if (!name) return;
      // Never try to invent shopify essentials — HttpOnly ones can't be cleared anyway
      domains.forEach(function (domain) {
        paths.forEach(function (path) {
          var base =
            name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;Max-Age=0;path=" + path;
          try {
            document.cookie = base;
            if (domain) document.cookie = base + ";domain=" + domain;
            document.cookie = base + ";SameSite=Lax";
            if (domain) document.cookie = base + ";domain=" + domain + ";SameSite=Lax";
          } catch (e) {}
        });
      });
    });
  }

  function removeWidgetDom() {
    try {
      var nodes = document.querySelectorAll(
        "#help-widget-moosedesk, [id*='moosedesk' i], [id*='help-widget' i], [class*='mdw-'], [class*='moose']"
      );
      Array.prototype.forEach.call(nodes, function (el) {
        try {
          el.remove();
        } catch (e) {}
      });
    } catch (e) {}
  }

  function wipeIndexedDb() {
    try {
      if (!window.indexedDB || typeof indexedDB.databases !== "function") return;
      indexedDB.databases().then(function (dbs) {
        (dbs || []).forEach(function (db) {
          if (!db || !db.name) return;
          try {
            indexedDB.deleteDatabase(db.name);
          } catch (e) {}
        });
      });
    } catch (e) {}
  }

  function clearCaches() {
    try {
      if (!window.caches || typeof caches.keys !== "function") return;
      caches.keys().then(function (keys) {
        keys.forEach(function (key) {
          try {
            caches.delete(key);
          } catch (e) {}
        });
      });
    } catch (e) {}
  }

  function clearMooseDeskSession() {
    nuclearClearStores();
    clearAllReadableCookies();
    removeWidgetDom();
    wipeIndexedDb();
    clearCaches();
  }

  function markPendingReset() {
    try {
      sessionStorage.setItem(PENDING_RESET, "1");
      localStorage.setItem(KEY, "guest");
    } catch (e) {}
  }

  /*
    Без това излезлият акаунт остава "online" за приятелите си,
    докато последният presence ping изтече.
  */
  function markPresenceOffline() {
    var url = "/apps/etournify/presence/offline?_ts=" + Date.now();

    try {
      if (navigator && typeof navigator.sendBeacon === "function") {
        navigator.sendBeacon(url, new Blob([], { type: "text/plain" }));
        return;
      }
    } catch (e) {}

    try {
      fetch(url, {
        method: "POST",
        credentials: "same-origin",
        keepalive: true,
        cache: "no-store"
      }).catch(function () {});
    } catch (e2) {}
  }

  function bindLogoutClears() {
    document.addEventListener(
      "click",
      function (event) {
        var el =
          event.target && event.target.closest
            ? event.target.closest(
                'a[href*="/account/logout"], a[href*="account/logout"], button[data-etn-logout], [data-etn-logout]'
              )
            : null;
        if (!el) return;

        var href = el.getAttribute("href") || "/account/logout";
        event.preventDefault();
        event.stopPropagation();

        try {
          markPresenceOffline();
        } catch (ePresence) {}

        try {
          clearMooseDeskSession();
          markPendingReset();
        } catch (e) {}

        window.location.href = href;
      },
      true
    );
  }

  function hardReloadFresh() {
    try {
      sessionStorage.setItem(RELOAD_FLAG, "1");
    } catch (e) {}
    var url = new URL(window.location.href);
    url.searchParams.set("etn_md_reset", String(Date.now()));
    window.location.replace(url.toString());
  }

  function stripResetParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has("etn_md_reset")) return;
      url.searchParams.delete("etn_md_reset");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function syncCustomerSession() {
    var current = currentCustomerKey();
    var prev = null;
    var pending = false;
    try {
      prev = localStorage.getItem(KEY);
      pending = sessionStorage.getItem(PENDING_RESET) === "1";
    } catch (e) {}

    if (pending) {
      clearMooseDeskSession();
      try {
        sessionStorage.removeItem(PENDING_RESET);
        localStorage.setItem(KEY, current);
      } catch (e) {}
    }

    if (prev == null) {
      try {
        localStorage.setItem(KEY, current);
      } catch (e) {}
      stripResetParam();
      return false;
    }

    if (prev === current) {
      stripResetParam();
      try {
        sessionStorage.removeItem(RELOAD_FLAG);
      } catch (e) {}
      return false;
    }

    // Account changed
    clearMooseDeskSession();
    try {
      localStorage.setItem(KEY, current);
    } catch (e) {}

    var alreadyReloading = false;
    try {
      alreadyReloading = sessionStorage.getItem(RELOAD_FLAG) === "1";
    } catch (e) {}

    if (!alreadyReloading) {
      hardReloadFresh();
      return true;
    }

    try {
      sessionStorage.removeItem(RELOAD_FLAG);
    } catch (e) {}
    stripResetParam();
    return false;
  }

  var ETN = ensureEtn();
  ETN.__mooseSessionReady = true;
  ETN.clearMooseDeskSession = clearMooseDeskSession;
  ETN.syncMooseDeskCustomerSession = syncCustomerSession;

  try {
    syncCustomerSession();
  } catch (e) {}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindLogoutClears);
  } else {
    bindLogoutClears();
  }

  function etnMooseHost() {
    return document.getElementById("moosedesk-widget-host");
  }

  function etnMooseRoot() {
    var host = etnMooseHost();
    if (host && host.shadowRoot) return host.shadowRoot;
    return document;
  }

  function etnParkHost(park) {
    var host = etnMooseHost();
    if (!host) return;
    if (park) {
      host.classList.remove("etn-mdw-open");
      host.style.setProperty("opacity", "0", "important");
      host.style.setProperty("visibility", "hidden", "important");
      host.style.setProperty("pointer-events", "none", "important");
    } else {
      host.classList.add("etn-mdw-open");
      host.style.setProperty("opacity", "1", "important");
      host.style.setProperty("visibility", "visible", "important");
      host.style.setProperty("pointer-events", "auto", "important");
    }
  }

  /* The corner bubble is never shown. Chat opens only from our own buttons
     (Support "Chat now", Help "Chat with us"), which click the hidden
     launcher programmatically, so it must stay in the DOM. */
  var ETN_BUBBLE_CSS =
    ".mdw-float-btn,.mdw-float-btn-message,.mdw-float-btn-img,.mdw-float-btn-img-container,.mdw-float-btn-only-icon{display:none!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;}";

  function etnInjectBubbleHideCss() {
    var host = etnMooseHost();
    if (host && host.shadowRoot) {
      var root = host.shadowRoot;
      if (!root.getElementById || !root.getElementById("etn-hide-mdw-bubble")) {
        var st = document.createElement("style");
        st.id = "etn-hide-mdw-bubble";
        st.textContent = ETN_BUBBLE_CSS;
        root.appendChild(st);
      }
      host.classList.add("etn-mdw-ready");
      return true;
    }
    if (!document.getElementById("etn-hide-mdw-bubble-light")) {
      var light = document.createElement("style");
      light.id = "etn-hide-mdw-bubble-light";
      light.textContent = ETN_BUBBLE_CSS;
      (document.head || document.documentElement).appendChild(light);
    }
    return false;
  }

  function etnHideMooseBubble() {
    try {
      etnInjectBubbleHideCss();
    } catch (eHide) {}
  }

  ETN.showMooseDeskHost = function () {
    etnInjectBubbleHideCss();
    etnParkHost(false);
  };

  function etnEnsureChatItem() {
    var panels = document.querySelectorAll(".etn-mnav-panel");
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var games = panel.querySelector(".etn-mnav-games");
      var chat = panel.querySelector('[data-etn-mnav="chat"]');
      if (chat && games && chat.previousElementSibling !== games) {
        if (games.nextSibling) games.parentNode.insertBefore(chat, games.nextSibling);
        else games.parentNode.appendChild(chat);
      }
    }
  }

  function etnOpenChatFromMenu() {
    window.__etnOpeningChat = true;
    etnParkHost(false);
    if (window.etnCloseMnav) window.etnCloseMnav();
    setTimeout(function () {
      if (window.ETN && typeof window.ETN.openMooseDeskChat === "function") {
        window.ETN.openMooseDeskChat();
      } else {
        try {
          window.location.hash = "#open-widget";
        } catch (err) {}
      }
      setTimeout(function () {
        window.__etnOpeningChat = false;
      }, 2500);
    }, 360);
  }

  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-etn-mnav="chat"]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      etnOpenChatFromMenu();
    },
    true
  );

  function etnChatTick() {
    etnEnsureChatItem();
    etnHideMooseBubble();
  }

  setTimeout(etnChatTick, 400);
  setTimeout(etnChatTick, 1200);
  setTimeout(etnChatTick, 3000);
  setTimeout(etnChatTick, 6000);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", etnChatTick);
  } else {
    etnChatTick();
  }

  /* MooseDesk mounts its host late; catch it as soon as it appears. */
  function etnWatchForHost() {
    if (!document.body || typeof MutationObserver !== "function") return;
    var watcher = new MutationObserver(function () {
      var host = etnMooseHost();
      if (host && host.shadowRoot) {
        etnInjectBubbleHideCss();
        watcher.disconnect();
      }
    });
    watcher.observe(document.body, { childList: true });
    setTimeout(function () {
      watcher.disconnect();
    }, 30000);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", etnWatchForHost);
  } else {
    etnWatchForHost();
  }
})();
